var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGesundheitsPlus = function SvgGesundheitsPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4043 52.4043C40.7643 52.4043 52.4043 40.7643 52.4043 26.4043C52.4043 12.0443 40.7643 0.404295 26.4043 0.404295C12.0443 0.404295 0.404297 12.0443 0.404297 26.4043C0.404297 40.7643 12.0443 52.4043 26.4043 52.4043Z",
    fill: "#FCBAC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5078 33.4994C24.5078 34.2873 24.663 35.0675 24.9645 35.7955C25.2661 36.5234 25.708 37.1849 26.2652 37.742C26.8223 38.2992 27.4838 38.7411 28.2117 39.0427C28.9397 39.3442 29.7199 39.4994 30.5078 39.4994C31.2957 39.4994 32.076 39.3442 32.8039 39.0427C33.5319 38.7411 34.1933 38.2992 34.7505 37.742C35.3076 37.1849 35.7496 36.5234 36.0511 35.7955C36.3526 35.0675 36.5078 34.2873 36.5078 33.4994C36.5078 31.9081 35.8757 30.382 34.7505 29.2567C33.6252 28.1315 32.0991 27.4994 30.5078 27.4994C28.9165 27.4994 27.3904 28.1315 26.2652 29.2567C25.14 30.382 24.5078 31.9081 24.5078 33.4994Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5078 30.4994V36.4994",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5078 33.4994H33.5078",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.473 32.7494L15.662 26.6844C14.8199 25.8425 14.2641 24.7569 14.0733 23.5815C13.8825 22.4061 14.0664 21.2005 14.599 20.1354C15.001 19.3314 15.5883 18.6345 16.3125 18.1021C17.0367 17.5697 17.8771 17.217 18.7644 17.0731C19.6517 16.9293 20.5605 16.9983 21.4158 17.2747C22.2711 17.551 23.0486 18.0266 23.684 18.6624L25.254 20.2274L26.82 18.6624C27.4554 18.0266 28.2328 17.551 29.0882 17.2747C29.9435 16.9983 30.8523 16.9293 31.7396 17.0731C32.6269 17.217 33.4673 17.5697 34.1915 18.1021C34.9157 18.6345 35.503 19.3314 35.905 20.1354C36.3016 20.9301 36.5062 21.8069 36.5022 22.6951C36.4982 23.5834 36.2858 24.4582 35.882 25.2494",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgGesundheitsPlus;